export function animateGalleryDialog(dialog, opening, previous) {
  const opacity = opening ? 0 : getComputedStyle(dialog).opacity;
  previous?.cancel();
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return null;
  return dialog.animate([{ opacity }, { opacity: opening ? 1 : 0 }], {
    duration: opening ? 400 : 320,
    easing: opening ? 'ease-out' : 'ease-in-out',
    fill: opening ? 'none' : 'forwards',
  });
}
